import { render, staticRenderFns } from "./AddNote.vue?vue&type=template&id=e85a9c6a&scoped=true&"
import script from "./AddNote.vue?vue&type=script&lang=ts&"
export * from "./AddNote.vue?vue&type=script&lang=ts&"
import style0 from "./AddNote.vue?vue&type=style&index=0&id=e85a9c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85a9c6a",
  null
  
)

export default component.exports